import React from 'react';
import './InfoPage.css';

const About = () => {
  return (
    <div className="info-page">
      <div className="page-header">
        <p className="page-eyebrow">About</p>
        <h1>Helping VIT Students Understand Their Progress</h1>
        <p className="page-lede">
          VIT CGPA Calculator is built by alumni who remember the stress of tracking
          credits, grade points, and academic milestones. The app bundles quick
          calculations, semester-by-semester tracking, and forward-looking planning into
          one focused experience built specifically for VIT&apos;s grading system.
        </p>
      </div>

      <div className="info-card">
        <h2 className="section-title">Why We Built This</h2>
        <p>
          During our time at VIT, we cobbled together spreadsheets to estimate our CGPA
          and understand what it would take to reach our targets. It was complicated,
          repetitive, and error-prone. We wanted to modernize that experience with an
          intuitive tool that is always available, visually clear, and tailored to the
          VIT credit structure.
        </p>
        <p>
          Launched in late 2024, this calculator has helped thousands of students track
          their academic progress with confidence. We continuously update the tool based
          on user feedback and VIT policy changes to ensure accuracy and relevance.
        </p>
      </div>

      <div className="info-card">
        <h2 className="section-title">What You Can Do</h2>
        <ul>
          <li>Calculate your CGPA instantly using either semester GPAs or individual course grades.</li>
          <li>Visualize semester performance and grade distribution with beautiful summaries.</li>
          <li>Forecast the grades you need in upcoming credits to hit a personal CGPA target.</li>
          <li>Save your data securely to the cloud and pick up where you left off across devices.</li>
          <li>Access a comprehensive FAQ covering common questions about VIT's grading system.</li>
          <li>Track progress over multiple years with automatic semester organization.</li>
        </ul>
      </div>

      <div className="info-card">
        <h2 className="section-title">Our Mission</h2>
        <p>
          We believe academic planning should be transparent and stress-free. By providing
          a fast, accurate, and accessible CGPA calculator, we empower VIT students to make
          informed decisions about course selection, study priorities, and career goals.
        </p>
        <p>
          Our roadmap includes multi-language support, mobile apps for iOS and Android,
          integration with official VIT systems (with university approval), and advanced
          analytics showing historical CGPA trends across cohorts.
        </p>
      </div>

      <div className="info-card">
        <h2 className="section-title">Development & Technology</h2>
        <p>
          Built with React and Firebase, the calculator uses modern web technologies for
          speed, security, and scalability. We follow privacy-first design principles—your
          academic data is encrypted, never sold to third parties, and completely under your
          control.
        </p>
        <p>
          The project is actively maintained with regular security updates, performance
          optimizations, and new features driven by student feedback. We conduct quarterly
          audits to verify calculation accuracy against official VIT grade conversion tables.
        </p>
      </div>

      <div className="info-card highlight-card">
        <h3>Independent Student Project</h3>
        <p>
          This project is not affiliated with VIT University or any of its departments. We
          created it to help fellow students and welcome feedback that improves accuracy,
          accessibility, and usability.
        </p>
      </div>

      <div className="info-card">
        <h2 className="section-title">Contact & Feedback</h2>
        <p>
          Have a suggestion, found an issue, or want to collaborate? Use the contact form on
          our <a href="/contact">Contact page</a>. We review every message and typically
          respond within two business days.
        </p>
      </div>
    </div>
  );
};

export default About;
